/* src/app/warehousing/pages/storage-rates-new/storage-rates-new.component.scss */
/*# sourceMappingURL=storage-rates-new.component.css.map */
